module.exports = __webpack_public_path__ + "static/media/noventa.91b2f528.svg";